import { IAvisEditableListFieldArrayProps } from "../../../types";
import { AvisEditableListAddButton } from "../../actions/AvisEditableListAddButton";
import { AvisEditableListHeaderCell } from "./";

export function AvisEditableListHeaderRow<T extends object, P extends object>(
  props: Readonly<IAvisEditableListFieldArrayProps<T, P>>,
) {
  const { fields, disabled } = props;

  return (
    <tr className="avis-editable-list-header-row">
      {!disabled && (
        <th className="actions">
          <AvisEditableListAddButton {...props} />
        </th>
      )}
      {fields.map((f) => (
        <AvisEditableListHeaderCell
          key={f.name.toString()}
          field={f}
          disabled={disabled}
        />
      ))}
    </tr>
  );
}
